import { useRef, useState } from "react";
import { FilterPanel, Input, Button, Title } from "../../components";
import CentresTable from "./components/CentresTable";
import useTableData from "../../hooks/useTableData";
import CentresService from "./centres.service";
import { events } from "../../utils/constants";
import { FaSearch } from "react-icons/fa";
import CreateCentreModal from "./components/createCentreModal";
import { useAuthenticationService } from "../../services/authentication.service";
import { roles } from "../../utils/constants";
import "./index.css";

function CentresPage() {
  const {
    data,
    sortColumn,
    sortType,
    loading,
    activeFilters,
    filtersRef,
    currentPage,
    pageSize,
    totalItems,
    searchTerm,
    handleSortColumn,
    applyFilters,
    getColumnValues,
    setFilterValues,
    getFilterValues,
    handlePageChange,
    handlePageSizeChange,
    handleSearchChange,
  } = useTableData({
    service: CentresService,
    initialFilters: {
      centreName: [],
      eceNumber: [],
      swnNumber: [],
      costCodeAlpha: []
    },
    entityName: "centres",
    serviceUpdateEvent: events.CENTRES_UPDATED,
    filterableColumns: ["swnNumber", "centreName", "eceNumber", "costCodeAlpha"],
    searchableColumns: ["swnNumber", "centreName", "eceNumber", "costCodeAlpha"],
    initialSortColumn: "centreName",
    columnTypes: {
      centreName: "string",
      eceNumber: "number",
      swnNumber: "number",
      costCodeAlpha: "string"
    },
  });

  // Authentication service to check user roles
  const AuthenticationService = useAuthenticationService();
  const isAdmin = AuthenticationService.isInAnyRole(roles.ADMINS);

  // UI state for the filter panel
  const activeFilterColumnKey = useRef(null);
  const [isCheckPickerOpen, setIsCheckPickerOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const openCheckPickerForColumn = (columnKey) => {
    activeFilterColumnKey.current = columnKey;
    setFilterValues(filtersRef.current[columnKey] || []);
    setIsCheckPickerOpen(true);
  };

  const applyCurrentFilters = () => {
    const selectedValuesFromPanel = getFilterValues();
    filtersRef.current = {
      ...filtersRef.current,
      [activeFilterColumnKey.current]: selectedValuesFromPanel,
    };
    applyFilters();
    setIsCheckPickerOpen(false);
  };

  function onFilterChange(selectedValues) {
    setFilterValues(selectedValues);
  }

  const cancelFiltering = () => {
    setIsCheckPickerOpen(false);
  };

  const getValuesForActiveColumn = () => {
    if (!activeFilterColumnKey.current) return [];
    return getColumnValues(activeFilterColumnKey.current);
  };

  // Handler to reload data after creating a centre
  const handleCentreCreated = () => {
    CentresService.loadData(true);
  };

  return (
    <div className="centres-page">
     
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, width: "100%" }}>
         <Title text="CENTRES" />
         <Input
          label="Search"
          value={searchTerm}
          onChange={(e) => handleSearchChange(e.target?.value || "")}
          placeholder="Search centres..."
          style={{ marginRight: 8, width: 400 }}
          icon={<FaSearch />}
        />

        <Button
          appearance="primary"
          type="button"
          className="create-centre-btn"
          onClick={() => setCreateModalOpen(true)}
          text="Create Centre"
          disabled={!isAdmin}
        />
          
      </div>
      {isCheckPickerOpen && activeFilterColumnKey.current && (
        <FilterPanel
          activeColumn={activeFilterColumnKey.current}
          filterOptions={getValuesForActiveColumn()}
          selectedValues={filtersRef.current[activeFilterColumnKey.current] || []}
          onApply={applyCurrentFilters}
          onCancel={cancelFiltering}
          onFilterChange={onFilterChange}
        />
      )}
      <CentresTable
        data={data}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={handleSortColumn}
        loading={loading}
        activeFilters={activeFilters}
        onFilterClick={openCheckPickerForColumn}
        currentPage={currentPage}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
      <CreateCentreModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSave={handleCentreCreated}
      />
    </div>
  );
}

export default CentresPage;
